import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dialogOpen: false,
  ssoToken: null,
  loading: false,
};

const cannySlice = createSlice({
  name: "canny",
  initialState,
  reducers: {
    setCannyLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCannyDialogOpen: (state, action) => {
      state.dialogOpen = action.payload;
      if (!action.payload) {
        // Reset token when closing dialog
        state.ssoToken = null;
      }
    },
    setCannyToken: (state, action) => {
      state.ssoToken = action.payload;
      state.loading = false;
    },
    resetCannyState: (state) => {
      state.dialogOpen = false;
      state.ssoToken = null;
      state.loading = false;
    },
  },
});

export const {
  setCannyLoading,
  setCannyDialogOpen,
  setCannyToken,
  resetCannyState,
} = cannySlice.actions;

export default cannySlice.reducer;
